import moment from 'moment';

/** 对比段 chip 最多可选段数（不含锚点按月拆段） */
export const STATISTICS_MAX_CUSTOM_COMPARE_PERIODS = 5;

/** 折线横轴最多点数（锚点按月拆段 + 对比段合计上限，支持 1~12 月） */
export const STATISTICS_MAX_TREND_AXIS_POINTS = 12;

export const normalizeCompareDateKey = (value) => {
	if (!value) return '';
	const parsed = moment(value);
	return parsed.isValid() ? parsed.format('YYYY-MM-DD') : String(value);
};

export const createCustomComparePeriod = (partial = {}) => ({
	id: partial.id ?? `custom-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
	label: partial.label ?? '',
	startDate: partial.startDate ?? null,
	endDate: partial.endDate ?? null,
	...(partial.periodAxis === 'quarter' || partial.periodAxis === 'month' ? { periodAxis: partial.periodAxis } : {}),
	...(Array.isArray(partial.months) && partial.months.length ? { months: partial.months } : {}),
	...(Array.isArray(partial.quarters) && partial.quarters.length ? { quarters: partial.quarters } : {}),
	...(partial.offsetYears != null ? { offsetYears: partial.offsetYears } : {}),
});

export const normalizeTrendAnchor = (anchor) => {
	if (!anchor?.startDate || !anchor?.endDate) return null;
	const months = Array.isArray(anchor.months)
		? [...new Set(anchor.months.map((month) => Number(month)).filter((month) => Number.isFinite(month) && month >= 0 && month <= 11))].sort((a, b) => a - b)
		: undefined;
	const quarters = Array.isArray(anchor.quarters)
		? [...new Set(anchor.quarters.map((quarter) => Number(quarter)).filter((quarter) => Number.isFinite(quarter) && quarter >= 0 && quarter <= 3))].sort((a, b) => a - b)
		: undefined;
	const periods = Array.isArray(anchor.periods)
		? anchor.periods
				.map((period) => ({
					startDate: normalizeCompareDateKey(period?.startDate),
					endDate: normalizeCompareDateKey(period?.endDate),
					...(Array.isArray(period?.orderCreatedMonths) && period.orderCreatedMonths.length
						? {
								orderCreatedMonths: [
									...new Set(period.orderCreatedMonths.map((month) => Number(month)).filter((month) => Number.isFinite(month) && month >= 1 && month <= 12)),
								].sort((a, b) => a - b),
							}
						: {}),
				}))
				.filter((period) => period.startDate && period.endDate)
		: undefined;
	const years = Array.isArray(anchor.years) ? [...new Set(anchor.years.map((year) => Number(year)).filter(Number.isFinite))].sort((a, b) => a - b) : undefined;
	return {
		startDate: normalizeCompareDateKey(anchor.startDate),
		endDate: normalizeCompareDateKey(anchor.endDate),
		label: anchor.label?.trim() ?? '',
		...(anchor.periodAxis === 'quarter' || anchor.periodAxis === 'month' ? { periodAxis: anchor.periodAxis } : {}),
		...(months?.length ? { months } : {}),
		...(quarters?.length ? { quarters } : {}),
		...(months?.length === 12 && quarters?.length === 4 ? { dualFullPeriod: true } : {}),
		...(periods?.length > 1 ? { periods } : {}),
		...(years?.length ? { years } : {}),
	};
};

export const normalizeCustomComparePeriods = (periods = []) =>
	periods
		.filter((item) => item?.startDate && item?.endDate)
		.slice(0, STATISTICS_MAX_CUSTOM_COMPARE_PERIODS)
		.map((item) => ({
			id: item.id,
			label: item.label ?? '',
			startDate: normalizeCompareDateKey(item.startDate),
			endDate: normalizeCompareDateKey(item.endDate),
			...(item.periodAxis === 'quarter' || item.periodAxis === 'month' ? { periodAxis: item.periodAxis } : {}),
			...(Array.isArray(item.months) && item.months.length ? { months: item.months } : {}),
			...(Array.isArray(item.quarters) && item.quarters.length ? { quarters: item.quarters } : {}),
			...(item.offsetYears != null ? { offsetYears: item.offsetYears } : {}),
		}));
